import { useLocation } from "react-router";
import type { Location } from "react-router";
import type { DemoEnrollmentStatus } from "shared/types/ExplorerPage";

export interface ExplorerPageLocation extends Location {
  state: { demoEnrollmentStatus: DemoEnrollmentStatus | undefined } | undefined;
}
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const useExplorerPageLocation = () => useLocation() as ExplorerPageLocation;
